import * as React from 'react';
import Title from '../Components/Title';

const WhatWeDo = () => {
    return (
        <>
            <p className="font-sans text-primary mb-[24px]">
                Wchodzi w życie 02.01.2022.
            </p>
            <Title
                className="text-[42px] mb-[24px]"
                style={{ marginTop: 0, marginBottom: 24 }}
                level={2}
                symbol="."
                withBlueSymbol
            >
                POLITYKA PRYWATNOŚCI I COOKIES
            </Title>
            <Title
                className="text-[18px] mb-[24px]"
                style={{ marginTop: 0 }}
                level={4}
            >
                Polityka Prywatności i Cookies (dalej: „Polityka”) ma charakter
                informacyjny, co oznacza, że nie jest ona źródłem obowiązków dla
                osób odwiedzających stronę internetową{' '}
                <a href="https://pl.spoton.com">https://pl.spoton.com</a>{' '}
                (dalej: „Serwis”).
            </Title>
            <Title
                className="text-[18px] mb-[24px]"
                style={{ marginTop: 0 }}
                level={4}
            >
                W przypadku pojawienia się jakichkolwiek pytań dotyczących
                przetwarzania Państwa danych osobowych, możecie je Państwo
                kierować na adres e-mail:{' '}
                <a href="poland-rodo@spoton.com">poland-rodo@spoton.com</a>.
            </Title>
            <Title
                level={4}
                className="text-[24px] leading-[140%]"
                style={{ marginBottom: 42, marginTop: 56 }}
            >
                I. ZAŁOŻENIA POLITYKI{' '}
            </Title>
            <p className="font-sans leading-[140%] text-[18px]">
                Celem Polityki jest:
            </p>
            <ul className="list-none">
                <li className="text-cta-large font-sans mb-[24px]">
                    a) przedstawienie zasad przetwarzania przez Administratora
                    danych osobowych w ramach Serwisu, a poprzez jej
                    udostępnienie przekazanie podmiotom danych niezbędnych
                    informacji na temat przetwarzania ich danych osobowych
                    zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady
                    (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony
                    osób fizycznych w związku z przetwarzaniem danych osobowych
                    i w sprawie swobodnego przepływu takich danych oraz
                    uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o
                    ochronie danych) (dalej: <strong>„RODO”</strong>);
                </li>
                <li className="text-cta-large font-sans mb-[24px]">
                    b) wyjaśnienie Państwa praw w odniesieniu do przetwarzanych
                    przez Administratora danych osobowych oraz sposobu ich
                    zabezpieczenia;
                </li>
                <li className="text-cta-large font-sans mb-[24px]">
                    c) przekazanie informacji o wykorzystywanych w ramach
                    Serwisu plikach cookie oraz zasadach ich akceptacji.
                </li>
            </ul>
            <Title
                level={4}
                className="text-[24px] leading-[140%]"
                style={{ marginBottom: 42, marginTop: 56 }}
            >
                II. INFORMACJE OGÓLNE{' '}
            </Title>
            <ol>
                <li className="text-cta-large font-sans mb-[24px]">
                    Administratorem Państwa danych osobowych jest:{' '}
                    <p className="text-cta-large font-sans mb-[24px]">
                        <strong>
                            SPOTON POLAND spółka z ograniczoną
                            odpowiedzialnością
                        </strong>{' '}
                        z siedzibą w Krakowie (ul. Aleja 29 Listopada 20, 31-401
                        Kraków), wpisana do rejestru przedsiębiorców Krajowego
                        Rejestru Sądowego prowadzonego przez Sąd Rejonowy Sąd
                        Rejonowy dla Krakowa - Śródmieścia w Krakowie Wydział XI
                        Gospodarczy - Krajowy Rejestr Sądowy, pod numerem KRS
                        0000807479, NIP 6762572293, REGON 384561488, adres
                        poczty elektronicznej:{' '}
                        <a href="mailto:poland-rodo@spoton.com">
                            poland-rodo@spoton.com
                        </a>
                        , numer telefonu: +48 739971460 (opłata jak za
                        połączenie standardowe - wg cennika właściwego
                        operatora) (dalej: <strong>„Administrator”</strong>).
                    </p>
                </li>
                <li className="text-cta-large font-sans mb-[24px]">
                    Administrator powołał osobę do kontaktu w sprawach Ochrony
                    Danych - Jakub Paczkowski, którego zadaniem jest czuwanie
                    nad prawidłowością przetwarzania danych osobowych. Kontakt z
                    nim możliwy jest pod adresem e-mail:{' '}
                    <a href="poland-rodo@spoton.com">poland-rodo@spoton.com</a>.
                </li>
                <li className="text-cta-large font-sans mb-[24px]">
                    Administrator zapewnia, że dokłada szczególnej staranności w
                    celu ochrony interesów osób, których dane dotyczą, a w
                    szczególności oświadcza że:
                    <ul className="list-none mt-6">
                        <li className="mb-6">
                            a) dane osobowe przetwarza zgodnie z prawem,
                            rzetelnie i w sposób przejrzysty dla osób, których
                            dane te dotyczą;
                        </li>
                        <li className="mb-6">
                            b) zbiera dane osobowe w konkretnych, wyraźnych i
                            prawnie uzasadnionych celach i nie przetwarzają ich
                            dalej w sposób niezgodny z tymi celami;
                        </li>
                        <li className="mb-6">
                            c) dane osobowe są adekwatne, stosowne oraz
                            ograniczone do tego, co niezbędne do celów, w
                            których są przetwarzane;
                        </li>
                        <li className="mb-6">
                            d) dane osobowe są prawidłowe i w razie potrzeby
                            uaktualniane;
                        </li>
                        <li className="mb-6">
                            e) przechowuje dane osobowe w formie umożliwiającej
                            identyfikację osoby, której dotyczą, przez okres nie
                            dłuższy, niż jest to niezbędne do celów, w których
                            są przetwarzane;
                        </li>
                        <li className="mb-6">
                            f) dane osobowe przetwarza w sposób zapewniający
                            odpowiednie bezpieczeństwo, w tym ochronę przed
                            niedozwolonym lub niezgodnym z prawem przetwarzaniem
                            oraz przypadkową utratą, zniszczeniem lub
                            uszkodzeniem, za pomocą odpowiednich środków
                            technicznych lub organizacyjnych.
                        </li>
                    </ul>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    Podanie przez Państwa danych osobowych jest dobrowolne, ale
                    niezbędne dla realizacji celów wskazanych w pkt III poniżej.
                </li>
            </ol>
            <Title
                level={4}
                className="text-[24px] leading-[140%]"
                style={{ marginBottom: 42, marginTop: 56 }}
            >
                III. CEL I PODSTAWA PRAWNA PRZETWARZANIA
            </Title>
            <p className="text-[18px] mb-[24px] font-sans">
                Państwa dane osobowe mogą być przetwarzane w różnych celach oraz
                w oparciu o różne podstawy prawne w zależności od tego z jakich
                funkcjonalności w ramach Serwisu Państwo korzystacie.
            </p>
            <ol>
                <li className="text-cta-large font-sans mb-6">
                    <b>KORZYSTANIE Z SERWISU</b>
                    <br /> ramach odwiedzania przez Państwa Serwisu oraz działań
                    podejmowanych w ramach Serwisu, Administrator może
                    przetwarzać Państwa dane osobowe (m.in. adres IP urządzenia,
                    z którego Państwo korzystacie), w następujących celach:
                    <ul className="list-none mt-6">
                        <li className="mb-6">
                            a) wypełnienia obowiązków prawnych ciążących na
                            Administratorze – podstawa prawna: art. 6 ust. 1
                            lit. c) RODO – niezbędność do wypełnienia obowiązku
                            prawnego ciążącego na Administratorze;
                        </li>
                        <li className="mb-6">
                            b) umożliwienia korzystania z Serwisu, prowadzenia
                            działań marketingowych, analitycznych oraz
                            statystycznych oraz zapewnienia bezpieczeństwa
                            Serwisu – podstawa prawna: art. 6 ust. 1 lit. f)
                            RODO – prawnie uzasadniony interes realizowany przez
                            Administratora;
                        </li>
                        <li className="mb-6">
                            c) ustalenia, dochodzenia lub obrony ewentualnych
                            roszczeń – podstawa prawna: art. 6 ust. 1 lit. f)
                            RODO – prawnie uzasadniony interes realizowany przez
                            Administratora.
                        </li>
                    </ul>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>PROWADZENIE REKRUTACJI</b>
                    <br />W związku z prowadzonymi procesami rekrutacyjnymi
                    przez Administratora, może on przetwarzać przekazane przez
                    Państwa dane osobowe (np. dane osobowe podane w CV), w
                    następujących celach:
                    <ul className="list-none mt-6">
                        <li className="mb-6">
                            a) na potrzeby realizacji przyszłych procesów
                            rekrutacyjnych oraz w przypadku (w przypadku
                            wyrażenia przez Państwa stosownej zgody) – podstawa
                            prawna: art. 6 ust. 1 lit. a) RODO – zgoda;
                        </li>
                        <li className="mb-6">
                            b) podjęcia działań na Państwa żądanie jako osoby,
                            której dane osobowe dotyczą, przed zawarciem umowy
                            (w przypadku zatrudnienia w oparciu o umowę inną niż
                            umowa o pracę) – podstawa prawna: art. 6 ust. 1 lit.
                            b) RODO;
                        </li>
                        <li className="mb-6">
                            c) rozpatrzenia kandydatury i realizacji procesu
                            rekrutacji – podstawa prawna: art. 6 ust. 1 lit. c)
                            RODO – niezbędność do wypełnienia obowiązku prawnego
                            ciążącego na Administratorze (w zakresie danych
                            osobowych, których podanie jest wymagane
                            obowiązującymi przepisami prawa) lub zgoda (w
                            przypadku danych osobowych, których podanie nie jest
                            to wymagane przepisami prawa) – podstawa prawna:
                            art. 6 ust. 1 lit. a) RODO;
                        </li>
                        <li className="mb-6">
                            d) ustalenia, dochodzenia lub obrony ewentualnych
                            roszczeń – podstawa prawna: art. 6 ust. 1 lit. f)
                            RODO – prawnie uzasadniony interes realizowany przez
                            Administratora.
                        </li>
                    </ul>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>FORMULARZ KONTAKTOWY</b>
                    <br /> Podane przez Państwa dane osobowe w związku z
                    przesłaniem zapytania za pośrednictwem formularza
                    kontaktowego mogą być przetwarzane przez Administratora w
                    następujących celach:
                    <ul className="mt-6 list-none">
                        <li className="mb-6">
                            a) wypełnienia obowiązków prawnych ciążących na
                            Administratorze – podstawa prawna: art. 6 ust. 1
                            lit. c) RODO – niezbędność do wypełnienia obowiązku
                            prawnego ciążącego na Administratorze;
                        </li>
                        <li className="mb-6">
                            b) obsługi Państwa zapytania i udzielenia
                            odpowiedzi, prowadzenie działań marketingowych,
                            analitycznych i statystycznych - podstawa prawna:
                            art. 6 ust. 1 lit. f) RODO – prawnie uzasadniony
                            interes realizowany przez Administratora;
                        </li>
                        <li className="mb-6">
                            c) ustalenia, dochodzenia lub obrony ewentualnych
                            roszczeń – podstawa prawna: art. 6 ust. 1 lit. f)
                            RODO – prawnie uzasadniony interes realizowany przez
                            Administratora.
                        </li>
                    </ul>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>OKRES PRZETWARZANIA</b>
                    <br /> Państwa dane osobowe mogą być przetwarzane przez
                    następujące okresy:
                    <ul className="list-none mt-6">
                        <li className="mb-6">
                            a) w związku z umożliwieniem korzystania z Serwisu
                            oraz potrzebą zapewnienia bezpieczeństwa systemu –
                            przez czas korzystania przez Państwa z Serwisu;
                        </li>
                        <li className="mb-6">
                            b) w związku z prowadzeniem przez Administratora
                            procesu rekrutacyjnego – przez okres niezbędny dla
                            przeprowadzenia procesu rekrutacyjnego, a w
                            przypadku kandydatów, którzy wyrazili stosowną zgodę
                            na przetwarzanie ich danych osobowych na potrzeby
                            przyszłych rekrutacji także przez odpowiedni okres
                            umożliwiający udział w przyszłych rekrutacjach, lecz
                            nie dłużej niż przez okres 24 miesięcy od złożenia
                            aplikacji przez kandydata;
                        </li>
                        <li className="mb-6">
                            c) w związku z przesłaniem zapytania za
                            pośrednictwem formularza kontaktowego – przez okres
                            niezbędny do rozpatrzenia Państwa zapytania i
                            udzielenia odpowiedzi;
                        </li>
                        <li className="mb-6">
                            d) w związku z prowadzonymi działaniami
                            marketingowymi, analitycznymi lub statystycznymi w
                            ramach dostępu do Serwisu – przez okres istnienia
                            prawnie uzasadnionego interesu Administratora lub do
                            czasu wniesienia przez Państwa sprzeciwu wobec
                            takiego przetwarzania;
                        </li>
                        <li className="mb-6">
                            d) w związku z ustaleniem, dochodzeniem lub obroną
                            przed ewentualnymi roszczeniami - przez okres ich
                            przedawnienia określony przez obowiązujące przepisy
                            prawa;
                        </li>
                        <li className="mb-6">
                            f) w związku z realizacją obowiązków prawnych
                            ciążących na Administratorze – przez okres niezbędny
                            do ich realizacji obowiązującymi przepisami prawa.
                        </li>
                    </ul>
                    <p>
                        W sytuacji, gdy Państwa dane osobowe są przetwarzane na
                        podstawie zgody, zgodę tę mogą Państwo wycofać w
                        dowolnym momencie, co nie będzie miało wpływu na
                        zgodność z prawem przetwarzania, którego dokonano na
                        podstawie zgody przed jej cofnięciem.
                    </p>
                    <p>
                        W zależności od zakresu danych osobowych i celów ich
                        przetwarzania, Państwa dane osobowe mogą być
                        przechowywane przez różny okres - w każdym przypadku
                        decyduje dłuższy termin przechowywania danych osobowych.
                    </p>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>ODBIORCY DANYCH</b>
                    <ol className="mt-6 ">
                        <li className="mb-6">
                            Administrator może udostępnić Państwa dane osobowe
                            podmiotom trzecim, z którymi współpracuje lub
                            nawiąże współpracę w ramach prowadzenia Serwisu.
                            Mogą być to podmioty, które pod względem technicznym
                            pomagają Administratorowi prowadzić Serwis, np.
                            dostawcy usług hostingu lub usług
                            teleinformatycznych. Ponadto, dane osobowe mogą być
                            także udostępniane podmiotom, które udzielają
                            wsparcia w komunikacji z klientami, realizacji
                            kampanii marketingowych oraz przeprowadzania
                            procesów rekrutacyjnych, jak również dostawcy usług
                            prawnych, księgowych i doradczych.
                        </li>
                        <li className="mb-6">
                            Administrator dokłada starań, aby podmioty trzecie,
                            którym udostępniane są dane osobowe w ramach
                            Serwisu, były zobowiązane do stosowania odpowiednich
                            środków zapewniających bezpieczeństwo i ochronę
                            Państwa danych osobowych. Państwa dane osobowe mogą
                            być przekazywane także innym spółkom w ramach grupy
                            kapitałowej, do której należy Administrator.
                        </li>
                        <li className="mb-6">
                            Państwa dane osobowe są co do zasady przetwarzane w
                            ramach Europejskiego Obszaru Gospodarczego (dalej:{' '}
                            <strong>„EOG”</strong>
                            ). Jednak w przypadku, gdy Administrator podejmie
                            współpracę z podmiotami trzecimi w zakresie
                            działalności Serwisu, Państwa dane osobowe mogą być
                            przekazywane do państwa spoza EOG, w którym podmiot
                            współpracujący z Administratorem utrzymuje narzędzia
                            służące do przetwarzania danych osobowych przy
                            współpracy z Administratorem. W takiej sytuacji,
                            przekazanie danych będzie następowało tylko w
                            niezbędnym zakresie, związanym ze świadczeniem usług
                            przez te podmioty na rzecz Administratora.
                        </li>
                        <li className="mb-6">
                            W przypadku przekazywania danych osobowych do
                            podmiotów mających siedzibę poza EOG, Administrator
                            zapewnia stosowanie wymogów określonych w rozdziale
                            5 RODO, w tym zastosowanie odpowiednich zabezpieczeń
                            przekazania w postaci standardowych klauzul umownych
                            przyjętych na mocy decyzji Komisji Europejskiej.
                            Mają Państwo możliwość uzyskania kopii zabezpieczeń
                            danych osobowych przekazywanych poza EOG,
                            kontaktując się z Administratorem pod adresem
                            e-mail:{' '}
                            <a href="mailto:poland-rodo@spoton.com">
                                poland-rodo@spoton.com
                            </a>
                            .
                        </li>
                    </ol>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>PRAWA OSÓB, KTÓRYCH DANE OSOBOWE DOTYCZĄ</b>
                    <br />W związku z przetwarzaniem Państwa danych osobowych,
                    jako osób, których dane osobowe dotyczą, macie Państwo prawo
                    do:
                    <ul className="mt-6 list-none">
                        <li className="mb-6">
                            a) dostępu do danych osobowych (w tym np. otrzymania
                            informacji, które dane osobowe są przetwarzane);
                        </li>
                        <li className="mb-6">
                            b) żądania sprostowania i ograniczenia przetwarzania
                            danych osobowych (np. jeśli są nieprawidłowe);
                        </li>
                        <li className="mb-6">
                            c) usunięcia danych osobowych (np. w przypadku, gdy
                            były one przetwarzane niezgodnie z prawem);
                        </li>
                        <li className="mb-6">
                            d) przenoszenia danych osobowych, które zostały
                            dostarczone Administratorowi, i które są
                            przetwarzane w sposób zautomatyzowany, a
                            przetwarzanie odbywa się na podstawie zgody lub na
                            podstawie niezbędność do wykonania umowy, np. do
                            innego administratora;
                        </li>
                        <li className="mb-6">
                            e) cofnięcia zgody (w przypadku gdy podstawą
                            przetwarzania danych osobowych jest zgoda) w
                            dowolnym momencie, przy czym cofnięcie zgody nie
                            wpływa na przetwarzanie dokonywane przez
                            Administratora zgodnie z prawem przed jej
                            cofnięciem;
                        </li>
                        <li className="mb-6">
                            f) wniesienia sprzeciwu wobec przetwarzania danych
                            osobowych opartego na przesłance niezbędności do
                            celów wynikających z prawnie uzasadnionych interesów
                            realizowanych przez Administratora lub przez stronę
                            trzecią, w tym w szczególności wobec przetwarzania
                            na potrzeby marketingu;
                        </li>
                        <li className="mb-6">
                            g) wniesienia skargi do Prezesa Urzędu Ochrony
                            Danych Osobowych.
                        </li>
                    </ul>
                </li>
                <li className="text-cta-large font-sans mb-6">
                    <b>PLIKI COOKIE</b>
                    <ol className="mt-6 ">
                        <li className="mb-6">
                            Administrator wykorzystuje pliki typu cookie (małe
                            pliki tekstowe, tzw. ciasteczka) lub o
                            funkcjonalności zbliżonej do cookies, które są
                            zapisywane w Państwa urządzeniu końcowym w związku z
                            korzystaniem z Serwisu.
                        </li>
                        <li className="mb-6">
                            Pliki cookie nie są szkodliwe ani dla Państwa ani
                            dla Państwa urządzenia. Ograniczenia stosowania
                            plików cookie mogą wpłynąć na niektóre
                            funkcjonalności dostępne w Serwisie, umożliwić lub
                            istotnie utrudnić prawidłowe korzystanie z Serwisu.
                        </li>
                        <li className="mb-6">
                            W wielu przypadkach przeglądarka internetowa
                            domyślnie dopuszcza przechowywanie plików cookie w
                            urządzeniu końcowym użytkownika. W każdej chwili
                            mogą Państwo usunąć pliki cookie przechowywane w
                            Państwa urządzeniu końcowym lub zablokować możliwość
                            ich zamieszczania w ustawieniach przeglądarki
                            internetowej. Jednocześnie informujemy, że usunięcie
                            lub zablokowanie umieszczenia niektórych plików
                            cookie może ograniczyć korzystanie z niektórych
                            funkcjonalności dostępnych w ramach Serwisu.
                        </li>
                        <li className="mb-6">
                            W ramach korzystania z Serwisu macie Państwo
                            możliwość wyboru zakresu stosowania technologii
                            plików cookie, a następnie wyrażenia stosownej zgody
                            odpowiadającej wybranemu zakresowi. W zależności od
                            tego na jaki zakres stosowania technologii plików
                            cookie wyrażą Państwo zgodę, takie pliki cookie będą
                            instalowane na urządzeniu końcowym.
                        </li>
                        <li className="mb-6">
                            Pliki cookie zbierają różnego rodzaju informacje,
                            które co do zasady nie stanowią danych osobowych
                            (nie pozwalają na Państwa identyfikację).Niektóre
                            informacje, w zależności od ich zawartości i sposobu
                            wykorzystania, mogą jednak zostać przypisane
                            konkretnej osobie, a tym samym zostać uznane za dane
                            osobowe. W stosunku do tego typu informacji stosuje
                            się odpowiednio postanowienia Polityki dotyczące
                            danych osobowych. W zakresie, w jakim pliki cookie
                            będą zawierać Państwa dane osobowe, podstawą ich
                            przetwarzania jest prawnie uzasadniony interes
                            Administratora lub strony trzeciej – art. 6 ust. 1
                            lit. f) RODO.
                        </li>
                        <li className="mb-6">
                            Szczegółowe informacje na temat sposobów
                            zablokowania / usunięcia plików cookie dostępne są w
                            sekcji „Pomoc” w menu przeglądarki internetowej.
                            Przykładowo w przeglądarce Internet Explorer pliki
                            cookie można modyfikować z poziomu: Narzędzia ->
                            Opcje internetowe -> Prywatność; w przeglądarce
                            Mozilla Firefox: Narzędzia -> Opcje -> Prywatność;
                            natomiast w przeglądarce Google Chrome: Ustawienia
                            -> Pokaż ustawienia zaawansowane -> Prywatność ->
                            Ustawienia treści -> Pliki cookie. Ścieżki dostępu
                            mogą różnić się w zależności od wykorzystywanej
                            wersji przeglądarki.
                        </li>
                        <li className="mb-6">
                            W ramach Serwisu stosowane są dwa zasadnicze rodzaje
                            plików cookie:
                            <ul className="mt-6 list-none">
                                <li className="mb-6">
                                    a) „sesyjne” (session cookies) – które są
                                    plikami tymczasowymi, które przechowywane są
                                    w Państwa urządzeniu końcowym do czasu
                                    opuszczenia strony internetowej lub
                                    wyłączenia oprogramowania (przeglądarki
                                    internetowej); oraz
                                </li>
                                <li className="mb-6">
                                    b) „stałe” (persistent cookies) – które są
                                    przechowywane w Państwa urządzeniu końcowym
                                    przez czas określony w parametrach plików
                                    cookie lub do czasu, kiedy je Państwo
                                    usuniecie.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-6">
                            Poza niezbędnymi plikami cookie (których
                            Administrator używa w celu zagwarantowania
                            prawidłowego działania Serwisu i bezpiecznego
                            korzystania z niego), w ramach Serwisu Administrator
                            może również używać następujących rodzajów plików
                            cookie:
                            <ul className="mt-6 list-none">
                                <li className="mb-6">
                                    a) analityczne / funkcjonalne – pliki cookie
                                    mające na celu przeprowadzanie analizy
                                    sposobu korzystania z Serwisu. Dzięki nim
                                    Administrator może m.in. określić liczbę
                                    osób odwiedzających Serwis, a także wykrywać
                                    nieprawidłowości w jego funkcjonowaniu i
                                    jednocześnie stale go ulepszać. Te pliki
                                    cookie ułatwiają Państwu także korzystanie z
                                    Serwisu (np. poprzez zapamiętanie podanych
                                    przez Państwa informacji oraz ustawień);
                                </li>
                                <li className="mb-6">
                                    b) marketingowe (reklamowe) – pliki cookie,
                                    które są wykorzystywane do prezentowania
                                    reklam dopasowanych do Państwa
                                    zainteresowań, a także mogą być
                                    wykorzystywane do dostosowania
                                    prezentowanych Państwu treści i reklam przez
                                    podmioty trzecie, z którymi Administrator
                                    współpracuje.
                                </li>
                            </ul>
                        </li>
                    </ol>
                </li>
                <li className="text-cta-large font-sans mb-20 ">
                    <b>POSTANOWIENIA KOŃCOWE</b>
                    <ol className="mt-6 ">
                        <li className="mb-6">
                            Niniejsza wersja Polityki obowiązuje od dnia
                            01.02.2022.
                        </li>
                        <li className="mb-6">
                            W związku z tym, że w ramach Serwisu mogą być
                            prezentowane odnośniki do zewnętrznych stron
                            internetowych, które nie należą do Administratora i
                            za które Administrator nie ponosi odpowiedzialności,
                            zalecane jest zapoznanie się z politykami
                            prywatności zamieszczonych na zewnętrznych stronach
                            internetowych, które należą do innych
                            administratorów.
                        </li>
                        <li className="mb-6">
                            Administrator zastrzega sobie prawo zmiany Polityki
                            - może to nastąpić m.in. z następujących ważnych
                            powodów:
                            <ul className="mt-6 list-none">
                                <li className="mb-6">
                                    a) zmiany obowiązujących przepisów, w
                                    szczególności w zakresie ochrony danych
                                    osobowych, prawa telekomunikacyjnego oraz
                                    usług świadczonych drogą elektroniczną
                                    wpływające na prawa i obowiązki
                                    Administratora lub osobę odwiedzającą
                                    Serwis;
                                </li>
                                <li className="mb-6">
                                    b) rozwój funkcjonalności lub usług
                                    elektronicznych podyktowany postępem
                                    technologii internetowej, w tym stosowanie /
                                    wdrożenie nowych rozwiązań technologicznych
                                    lub technicznych, mające wpływ na zakres
                                    Polityki.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-6">
                            Administrator każdorazowo umieści w ramach Serwisu
                            informację o zmianach w Polityce. Każdorazowo po
                            zmianie Polityki, nowa wersja Polityki będzie się
                            pojawiać z nową datą obowiązywania.
                        </li>
                    </ol>
                </li>
            </ol>
        </>
    );
};

export default WhatWeDo;
